'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserActivityCategory } from '../../Entities/User/UserActivityCategory';
import { UserActivityCategoryCollection } from '../../Collections/User/UserActivityCategoryCollection';
export class UserActivityCategoryRepository extends CoreRepository {
  public getUserActivitiesSavedCategories(userId: number) {
    return this.webAPI.getUserActivitiesSavedCategories(userId).then((response) => {
      const collection = new UserActivityCategoryCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserActivityCategory();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserActivityCategory(userId: number, payload: object = {}) {
    return this.webAPI.addUserActivityCategory(userId, payload).then((response) => {
      const item = new UserActivityCategory();
      item.hydrate(response);

      return item;
    });
  }

  public removeUserActivityCategory(userId: number, catergoryId: number) {
    return this.webAPI.removeUserActivityCategory(userId, catergoryId).then((response) => {
      return response;
    });
  }

  public updateUserActivityCategory(userId: number, catergoryId: number, payload: any[]) {
    return this.webAPI.updateUserActivityCategory(userId, catergoryId, payload).then((response) => {
      return response;
    });
  }

  /*
    public getUserActivityCategory(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserActivityCategory(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserActivityCategory = new UserActivityCategory();
            UserActivityCategory.hydrate(response);

            return UserActivityCategory;
        });
    }

    public createUserActivityCategory(payload: object = {}){  
    return this.webAPI.createUserActivityCategory(payload)
      .then( response => {
        let UserActivityCategory = new UserActivityCategory();
        UserActivityCategory.hydrate(response);

        return UserActivityCategory;
      });
    }

    public updateUserActivityCategory(payload: object = {}){  
        return this.webAPI.updateUserActivityCategory(payload)
        .then( response => {
            let UserActivityCategory = new UserActivityCategory();
            UserActivityCategory.hydrate(response);

            return UserActivityCategory;
        });
    }

    public removeUserActivityCategory( ){
        return this.webAPI.removeUserActivityCategory()
        .then( response => {
            return response;
        });
    }
    */
}
